import { hillo } from 'hillo'
import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import GlobalConfig from '@/model/global/GlobalSettings'
import { cloudV2Url } from '@/model/dataLayer/api/SaaS/SaaSUtils'
import dayjs from 'dayjs'
import VipUser from '@/model/dataLayer/api/Vip/VipUser'

const voucherPath = 'membership/voucher/'
const entity = {
  name: {},
  discountStr: {},
  createTimestamp: {},
  used: {
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  },
  userId: {
    displayName: 'user',
    type: IKDataEntity.Types.Option,
    formConfig: {
      type: {
        selectItems: async () => {
          return (await VipUser.getList(true))
        },
        itemText: 'username',
        itemValue: 'userId'
      }
    }
  },
  detail: {
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true
    }
  }
}
const config = {
  load: async function () {
    return (await hillo.get(cloudV2Url + voucherPath + 'voucher-record/' + GlobalConfig.blId, {})).map(it => {
      it.name = it.voucherInfo.displayInfo.name
      it.discountStr = it.voucherInfo.discountStr
      it.createTimestamp = dayjs(it.createTimestamp).format('YYYY-MM-DD HH:mm:ss')
      return it
    })
  }
}

export default IKDataEntity.ModelFactory(entity, config)
